import { ca } from '@cian/analytics';

type TAnalyticsParameters = {
  label: string;
  offerId: number;
  position: number;
};

export function trackAddToFavorite({ label, offerId, position }: TAnalyticsParameters) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: 'add',
    label,
    page: {
      pageType: 'ListingFavorites',
      extra: {
        block: 'recommendations',
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position,
      },
    ],
  });
}

export function trackDeleteFromFavorite({ label, offerId, position }: TAnalyticsParameters) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: 'remove',
    label,
    page: {
      pageType: 'ListingFavorites',
      extra: {
        block: 'recommendations',
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position,
      },
    ],
  });
}
